import{styled as e}from"styled-components";const n=e.input`
  font: 1em Consolas;
  height: 19px;
  min-width: 30px;
  max-width: 450px;
  border: 0px;
  margin: 0px;
  outline: none;
  white-space: nowrap;
  line-height: 22px;
  vertical-align: middle;
  background: none;
  /* delete Edge password reveal button */
  &::-ms-reveal {
    display: none;
  }
`;export{n as BaseInput};
